import React, {forwardRef, useState} from "react";
import {AutoComplete, Button, ButtonToolbar, DatePicker, Form, Modal, SelectPicker} from 'rsuite';
import {addNewUserDegree} from "../../../service/degreeService";
import {educationModel} from "../../form/models";
import {commonMajors} from "../../constants/commonMajors";

const dateEarnedInstance = forwardRef((props, ref) =>
    <DatePicker {...props} format="yyyy-MM" oneTap ranges={[]} style={{width: 200}} ref={ref}/>
);

const AddEducationModal = (props) => {
    const { open, handleClose, degrees, userId } = props;

    const [localState, setLocalState] = useState({userId});

    const submitDegreeAdd = (isFormValid) => {
        if(!isFormValid) return;
        addNewUserDegree(localState).then((response) => {
            handleClose(response);
        });
    };

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = (event) => {
        setLocalState({...localState, ...event});
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            backdrop="static"
        >
            <Modal.Header>
                <Modal.Title>Add Degree</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    If you need a new degree name/type added please see an administrator.
                </p>
            </Modal.Body>
            <Form
                layout="horizontal"
                model={educationModel}
                onChange={handleFormChange}
                onSubmit={submitDegreeAdd}
            >
                <Form.Group>
                    <Form.ControlLabel>Degree Name</Form.ControlLabel>
                    <Form.Control name="degreeName"
                                  accepter={SelectPicker}
                                  data={degrees}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Institution</Form.ControlLabel>
                    <Form.Control name="institution"/>
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Major</Form.ControlLabel>
                    <Form.Control name="major"
                                  accepter={AutoComplete}
                                  data={commonMajors}
                                  style={{width: 300}}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Minor</Form.ControlLabel>
                    <Form.Control name="minor" />
                </Form.Group>
                <Form.Group>
                    <Form.ControlLabel>Date Earned</Form.ControlLabel>
                    <Form.Control name="dateEarned"  accepter={dateEarnedInstance}/>
                </Form.Group>
                <Form.Group>
                    <ButtonToolbar>
                        <Button type="submit" appearance="primary">
                            Ok
                        </Button>
                        <Button onClick={handleClose} appearance="default">
                            Cancel
                        </Button>
                    </ButtonToolbar>
                </Form.Group>
            </Form>
        </Modal>
    );
}

export default AddEducationModal;